import {ReportTableColumn, ReportTableConfigInterface, ReportTableData} from 'appShared/components/report-table';
import {
    MarketDataFeedsCostAlaricNonProSelector,
    MarketDataFeedsCostAlaricProSelector,
    MarketDataFeedsCostIndividualNonProSelector,
    MarketDataFeedsCostIndividualProSelector,
    MarketDataFeedsCurrencySelector,
    MarketDataFeedsDateSelector,
    MarketDataFeedsDescriptionSelector,
    MarketDataFeedsExchangeSelector,
    MarketDataFeedsModifiedBySelector
} from 'appAssets/selectors';

export const PanelMarketDataFeedsPriceHistoryDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Date',
                selector: MarketDataFeedsDateSelector,
            }),
            new ReportTableColumn({
                label: 'Created By',
                selector: MarketDataFeedsModifiedBySelector,
            }),
            new ReportTableColumn({
                label: 'Cost To Alaric (pro)',
                selector: MarketDataFeedsCostAlaricProSelector,
            }),
            new ReportTableColumn({
                label: 'Cost To Alaric (non-pro)',
                selector: MarketDataFeedsCostAlaricNonProSelector,
            }),
            new ReportTableColumn({
                label: 'Individual Price (pro)',
                selector: MarketDataFeedsCostIndividualProSelector,
            }),
            new ReportTableColumn({
                label: 'Individual Price (non-pro)',
                selector: MarketDataFeedsCostIndividualNonProSelector,
            })
            ,
            new ReportTableColumn({
                label: 'Currency',
                selector: MarketDataFeedsCurrencySelector,
            })
        ],
        hiddenColumnIds: [],
        actionMenu: false
    };
};

export const PanelMarketDataFeedsPriceHistoryDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: MarketDataFeedsDateSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MarketDataFeedsModifiedBySelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MarketDataFeedsCostAlaricProSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MarketDataFeedsCostAlaricNonProSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MarketDataFeedsCostIndividualProSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MarketDataFeedsCostIndividualNonProSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MarketDataFeedsCurrencySelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MarketDataFeedsExchangeSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: MarketDataFeedsDescriptionSelector,
            value: null,
            hidden: false
        })
    ];
};
